import React from 'react';

const CTA = () => {
  return (
    <section id='cta'>
      <div className='container tc'>
        <div className='s-64'></div>
        <h3 className='title-sub'>Master the Profession of the Future</h3>
        <div className='s-32'></div>
        <h4 className='title-mini w-60 ma'>
          Start earning a decent living with German state funding support
        </h4>
        <div className='s-48'></div>
        <div className='card tl b-none p-5'>
          <div className='m-5'>
            <div className='row'>
              <div className='col-lg-6'>
                <h3 className='title-sub w-100' style={{ lineHeight: 1.2 }}>
                  Choose your learning track now with German funding
                </h3>
                <div className='s-40'></div>
                <a href='/sign-in' className='button'>
                  Choose Track
                </a>
              </div>
              <div className='col-lg-6'></div>
            </div>
          </div>
        </div>
        <div className='s-80'></div>
      </div>
    </section>
  );
};

export { CTA };
